import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts"

const TopCategoriesBar = ({ data }) => (
  <ResponsiveContainer width="100%" height="100%">
    <BarChart 
      data={data}
      margin={{ top: 20, right: 20, left: 10, bottom: 30 }}
    >
      <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.2} />
      <XAxis
        dataKey="categoryName"
        tick={{ fontSize: 12 }}
        angle={-25}
        textAnchor="end"
        interval={0}
      />
      <YAxis tick={{ fontSize: 12 }} />
      <Tooltip
        contentStyle={{
          borderRadius: "12px",
          border: "none",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      />
      <Bar 
        dataKey="totalGrievances" 
        fill="#004877" 
        barSize={24}
        // radius={[10, 10, 10, 10]}
      />
    </BarChart>
  </ResponsiveContainer>
)

export default TopCategoriesBar
